import React from "react";

const SideNavItem = ({ icon, label, href, isActive, showError }) => {
  return (
    <a
      href={href}
      className={`list-group-item ${isActive ? "form-basic-active" : ""}`}
      style={isActive ? { borderLeft: "3px solid #6F63B8" } : {}}
    >
      <i className={`fa ${icon}`}></i> {label}
      {showError && (
        <small className="pull-right">
          <span style={{ color: "red" }} className="fa fa-times-circle"></span>
        </small>
      )}
    </a>
  );
};

export default SideNavItem;
